"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryWrapper = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var UI_1 = require("../ui/UI");
function checkHasData(data) {
    if (Array.isArray(data)) {
        return data.length > 0;
    }
    if (typeof data === 'object') {
        return Object.keys(data).length > 0;
    }
    return data !== null && data !== undefined;
}
function QueryWrapper(_a) {
    var children = _a.children, data = _a.data, props = tslib_1.__rest(_a, ["children", "data"]);
    var isLoading = props.isLoading, error = props.error, noData = props.noData;
    var _b = UI_1.useUIContext(), useLoader = _b.useLoader, useErrorAlert = _b.useErrorAlert, useWarningAlert = _b.useWarningAlert;
    var _c = useLoader({ isLoading: isLoading }), loader = _c.loader, setLoading = _c.setLoading;
    var _d = useWarningAlert(), warningAlert = _d.warningAlert, setWarningAlert = _d.setWarningAlert;
    var _e = useErrorAlert(), errorAlert = _e.errorAlert, setErrorAlert = _e.setErrorAlert;
    var _f = tslib_1.__read(react_1.useState(), 2), childrenData = _f[0], setChildrenData = _f[1];
    react_1.useEffect(function () {
        setLoading(isLoading);
        setErrorAlert(!isLoading && error ? error : undefined);
        var hasData = checkHasData(data);
        setChildrenData(!isLoading && !error && hasData
            ? children(tslib_1.__assign({ data: data,
                setLoading: setLoading,
                setErrorAlert: setErrorAlert,
                setWarningAlert: setWarningAlert }, props))
            : undefined);
        setWarningAlert(error || isLoading || !noData || hasData ? undefined : noData);
    }, [isLoading, error, data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        loader,
        errorAlert,
        warningAlert,
        childrenData));
}
exports.QueryWrapper = QueryWrapper;
//# sourceMappingURL=QueryWrapper.js.map